export const hasParentClass = (el: any, className: string) => {
  if (el === document) return false;
  if (el.classList.contains(className)) return true;
  return el.parentNode && hasParentClass(el.parentNode, className);
};

export const enableBodyScroll = () => {
  document.getElementsByTagName("body")[0].classList.remove("popup-is-open");
};

export const disableBodyScroll = () => {
  document.getElementsByTagName("body")[0].classList.add("popup-is-open");
};

export function easeInOutCubic(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
  return (c / 2) * ((t -= 2) * t * t + 2) + b;
}

export function getParameterByName(name, url?) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getSelfOrNearestAncestorByClassName(el: Element, className: string): Element {
  const maxDepth: number = 5;
  let currentDepth: number = 0;
  let element: any = el;

  do {
    currentDepth++;

    if (element.classList && element.classList.contains(className)) {
      return element;
    }
    element = currentDepth !== maxDepth ? element.parentNode : null;
  } while (element);

  return null;
}
